<script setup lang="ts">
import VuePdfEmbed from 'vue-pdf-embed'
import type { IProps } from './UiPdfEmbed.types'
import Loader from '@/components/Loader/Loader.vue'

defineProps<IProps>()

const isRendered = ref(false)

function handleDocumentRender() {
  isRendered.value = true
}

</script>

<template>
  <ClientOnly>
    <UiSection
      color="grey"
      class="section--pdf"
    >
      <UiButton
        v-if="buttonLabel && isRendered"
        :to="source"
        :target="'_blank'"
        class="section--pdf_button"
      >
        {{ buttonLabel }}
      </UiButton>

      <VuePdfEmbed
        :source="source"
        @rendered="handleDocumentRender"
      />

      <Loader v-if="!isRendered" />
    </UiSection>
  </ClientOnly>
</template>

<style lang="scss" scoped>
.section {
    &.section--pdf {
        @include section-centered();
        min-height: 20rem;

        :deep(.section--pdf_button) {
            margin: 4.8rem auto 0 auto;
        }

        :deep(.loader) {
            margin-right: auto;
            margin-left: auto;
        }

        :deep(.vue-pdf-embed) {
            margin-top: 4.8rem;
            overflow-x: auto;

            @include atXL {
                margin-top: 9.6rem;
            }
        }

        :deep(.vue-pdf-embed__page) {
            min-width: 57.7rem;
            width: 100%;
            height: auto;

            canvas {
                min-width: 57.7rem;
                width: 100% !important;
                height: auto !important;
            }
        }
    }
}
</style>
